//
// AccessibilityElement.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "../pickResults/PickResult";
import "./PointVectorObject";
import "./PickedNodeInfo";
import "../gestures/GestureDirectionType";

var AccessibilityElement = createModule("commons::AccessibilityElement", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getPickResult: [1],
        getAccessibilityChildren: [[1]],
        getLocation: [4],
        getNodeInfo: [1],
        getTerseAccessibilityLabel: [7],
        getExtendedAccessibilityFrame: [12,12,4],
        isSelected: [2],
        getAccessibilityHint: [7],
        getPoints: [[1]],
        getAccessibilityLabel: [7],
        getAccessibilityFrame: [12],
    },
    ,
    ,
]);
export default AccessibilityElement;
